import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=accc3cb6&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=accc3cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc3cb6",
  null
  
)

export default component.exports